import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJConfirmModalContainer from "./FJConfirmModalContainer";
import FJRecordingModalContainer from "./FJRecordingModalContainer";
import FJRecordingTimingModalContainer from "./FJRecordingTimingModalContainer";
import FJLoadingModalContainer from "./FJLoadingModalContainer";
import FJTextEditorModalContainer from './FJTextEditorModalContainer';
import FJRelinkModalContainer from "./FJRelinkModalContainer";
import FJRecordFromModalContainer from "./FJRecordFromModalContainer";
import FJQuickGuideModalContainer from "./FJQuickGuideModalContainer";
import FJUnsupportSafariModalContainer from "./FJUnsupportSafariModalContainer";
import FJStockVideoModalContainer from "./FJStockVideoModalContainer";
import FJStockDetailsModelContainer from "./FJStockDetailsModelContainer";
import FJDropboxLoadingModalContainer from "./FJDropboxLoadingModalContainer";
import FJDropboxSuccessModalContainer from "./FJDropboxSuccessModalContainer";
import FJCloudBenefitModalContainer from "./FJCloudBenefitModalContainer";


class FJModalContainer extends Component {

  render() {
    return (
      <>
        <FJLoadingModalContainer />
        <FJRecordingModalContainer />
        <FJRecordingTimingModalContainer />
        <FJTextEditorModalContainer />
        <FJRelinkModalContainer />
        <FJRecordFromModalContainer />
        <FJQuickGuideModalContainer />
        <FJConfirmModalContainer />
        <FJUnsupportSafariModalContainer />
        <FJStockVideoModalContainer />
        <FJStockDetailsModelContainer />
        <FJDropboxLoadingModalContainer />
        <FJDropboxSuccessModalContainer />
        <FJCloudBenefitModalContainer />
      </>
    )
  }
}

const mapStateToProps = function () {
  return {
  }
};

const mapDispatchToProps = function () {
  return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(FJModalContainer);
